/**
 * User agent sniffing helpers
 *
 * @module 00-utilities/ua-sniffing
 */


/**
 * Check if the user agent matches a mobile browser one.
 *
 * @returns {boolean}
 *   True if the current browser is a mobile one, false otherwise.
 */
function uaIsMobile() {
  return /mobi/i.test( navigator.userAgent );
}


/**
 * Check if the user agent matches IE 11
 *
 * @returns {boolean}
 *   True if the current browser is a mobile one, false otherwise.
 */
function uaIsIE11() {
  const appName = navigator.appName;
  return (
    appName === 'Microsoft Internet Explorer' ||
    (
      appName === 'Netscape' &&
      /Trident\/.*rv:([0-9]+[.0-9]*)/.test( navigator.userAgent )
    )
  );
}


/**
 * Check if the user agent matches IE 11
 *
 * @returns {boolean}
 *   True if the current browser is a mobile one, false otherwise.
 */
function uaIsEdge12() {
  return (
    navigator.appName === 'Netscape' &&
    /Edge\/12/.test( navigator.userAgent )
  );
}


export {
  uaIsMobile,
  uaIsIE11,
  uaIsEdge12
};
